import React, { Component } from 'react';
import Checkbox from 'src/ui/library/Checkbox';
import InfoTooltip from 'src/ui/library/ContentParser/controls/Tooltip/InfoTooltip';
import WithHeader from '../../wrappers/WithHeader';

class CheckboxControl extends Component {
  valueTransform = event => {
    this.props.onChange({ target: { value: event.target.value.toString().toLowerCase() } });
  };

  render() {
    const { value, label, helpText } = this.props;
    let labelText = label;

    if (label && helpText) {
      labelText = <InfoTooltip toolTipText={helpText} labelText={labelText} inlineLabel />;
    }

    return <Checkbox checked={value || false} onChange={this.valueTransform} label={labelText} />;
  }
}

export default WithHeader(CheckboxControl);
